
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        item: Object as any,
    },
})
